export const resignationState = {
  employeeName: "Meera",
  employeeId: "EMP11223",
  designation: "Software Developer",
  department: "Engineering",
  dateOfResignation: "2025-05-08",
  reason: "Personal",
  otherReason: "",
  noticePeriod: "I will serve the notice period",
  noticeOption: "30",
  

  employeeNameStatus: "Meera",
  employeeIdStatus: "EMP11223",
  designationStatus: "Software Developer",
  departmentStatus: "Engineering",
  dateOfResignationStatus: "2025-05-08",
  reasonStatus: "Personal",
  otherReasonStatus: "Reason",
  noticePeriodStatus: "30 days",
};

export const resignationStateMange = (state, action) => {

  console.log(action,"act");
  console.log(state,"state");
  
  
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "employeeName": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          employeeName: value,
          employeeNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          employeeName: "",
          employeeNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          employeeName: value,
          employeeNameStatus: "error",
        };
      }
    }
    case "employeeId": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          employeeId: value,
          employeeIdStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          employeeId: "",
          employeeIdStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          employeeId: value,
          employeeIdStatus: "error",
        };
      }
    }
    case "designation": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          designation: value,
          designationStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          designation: "",
          designationStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          designation: value,
          designationStatus: "error",
        };
      }
    }
    case "department": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          department: value,
          departmentStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          department: "",
          departmentStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          department: value,
          departmentStatus: "error",
        };
      }
    }
    case "dateOfResignation": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          dateOfResignation: value,
          dateOfResignationStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          dateOfResignation: "",
          dateOfResignationStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          dateOfResignation: value,
          dateOfResignationStatus: "error",
        };
      }
    }
    case "reason": {
      if (value) {
        return {
          ...state,
          reason: value,
          reasonStatus: "success",
          otherReason: "",
          otherReasonStatus: "unchecked",
        };
      } else if (!value) {
        return {
          ...state,
          reason: "",
          otherReason: "",
          otherReasonStatus: "unchecked",
          reasonStatus: "unchecked",
        };
      }
    }
    case "otherReason": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          otherReason: value,
          otherReasonStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          otherReason: "",
          otherReasonStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          otherReason: value,
          otherReasonStatus: "error",
        };
      }
    }
    case "noticePeriod": {
      if (value) {
        return {
          ...state,
          noticePeriod: value,
          noticePeriodStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          noticePeriod: "",
          noticePeriodStatus: "unchecked",
        };
      }
    }
    case "noticeOption": {
      if (value) {
        return {
          ...state,
          noticeOption: value,
          noticeOptionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          noticeOption: "",
          noticeOptionStatus: "unchecked",
        };
      }
    }

    default:
      return state;
  }
};

export const noticeperiodDaysOptions = [
  { value: "7 days", label: "7 days"},
  { value: "15 days", label: "15 days"},
  { value: "30 days", label: "30 days"},
  { value: "45 days", label: "45 days"},
  { value: "60 days", label: "60 days"},
  { value: "75 days", label: "75 days"},
  { value: "90 days", label: "90 days"},
  
]

export const resignationReasonOptions = [
  "Better Offer",
  "Higher Studies",
  "Work Environment",
  "Family Circumstances",
  "Others",
];

export const noticePeriodOffer = [
  "I will serve the notice period.",
  "Request to waive the notice period.",
];
